document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('bundler:bundle_widget_created', function(e) {
      console.log('bundle created')
      const button = document.getElementById('bundle-btn'); 
      if (button) {
          button.classList.remove('opacity-0'); // Show the "Shop the whole look" button if bundle is found
      }
    })
})